import { render, staticRenderFns } from "./Component-AddContact.vue?vue&type=template&id=8923054a&"
import script from "./Component-AddContact.vue?vue&type=script&lang=js&"
export * from "./Component-AddContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports